import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { TrainingEventSubscription } from '../../models/domain/training.event.subscription';
import { AdvancedSearchResultMemberItem } from '../../../app/models/domain/advanced.searche.results';
import { AdvancedSearchItem } from '../../../app/models/domain/advanced.search.item';
import { TransferChildToMemberRequest } from '../../../app/models/ss-api/requests/transfer.child.to.member.request';
import { Router } from '@angular/router';

export interface ITransferMemberDialogModel {
    title: string;
    MemberID: number;
}

@Component({
    selector: 'transfer-member-dialog',
    styleUrls: ['./transfer.member.dialog.css'],
    templateUrl: './transfer.member.dialog.html'
})

export class TransferMemberDialog extends DialogComponent<ITransferMemberDialogModel, TrainingEventSubscription> implements ITransferMemberDialogModel, OnInit {
    IsBusy: Boolean = false;

    title: string;
    MemberID: number;

    searched: boolean = false;
    SearchQuery: string;
    SearchResponse: AdvancedSearchResultMemberItem[];

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {

    }

    SearchForMember() {
        this.IsBusy = true;
        let query = new AdvancedSearchItem();
        query.SmartSearch = this.SearchQuery;

        let disposable = this.api.SearchAdvanced(query).subscribe(response => {
            this.IsBusy = false;
            disposable.unsubscribe();
            this.searched = true;
            this.SearchResponse = response.Data.Data;
        })
    }

    SelectMember(id: number) {
        let request: TransferChildToMemberRequest = {
            ChildMemberID: this.MemberID,
            NewParentMemberID: id
        }

        this.sweetAlert.swal({
            type: 'warning',
            title: 'Are you sure?',
            text: 'This action cannot be undone. Please be careful.',
            showCancelButton: true,
            preConfirm: () => {
                return this.api.TransferChildToMember(request).toPromise();
            }
        }).then((response) => {
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Transfer Successful',
                    text: 'Designer has been transferred to member',
                    timer: 1500
                }).then(() => { }, () => { })
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message
                }).then(() => { }, () => { })
            }
        }, (dismiss) => {

        })
    }

}
